export default __webpack_public_path__ + "static/easetwo-ae9dffa8b28db3ade3b760d1f3bcf31d.png";